import { BASE_URL } from "@/services/api/base";

export const getNewsEndpoint = `${BASE_URL}/News/GetNews`;
export const getNewsPageContentEndpoint = `${BASE_URL}/ContentPage/GetPageContents`;
